import { languageHelper } from "../../../../config/helperFunctions";
import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";

function KitchenPerformanceReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },

    {
      header: languageHelper("Date"),
      accessorKey: "created_at",
      cell: (info) => (info.getValue() ? info.getValue().split("T")[0] : ""),
    },
    {
      header: languageHelper("Order Number"),
      accessorKey: "sale_no",
    },
    {
      header: languageHelper("Type"),
      accessorKey: "order_type",
      cell: (info) => info.getValue().name,
    },
    {
      header: languageHelper("Order Time"),
      accessorKey: "order_time",
    },
    {
      header: languageHelper("Cooking Start Time"),
      accessorKey: "cooking_start_time",
    },
    {
      header: languageHelper("Cooking End Time"),
      accessorKey: "cooking_end_time",
    },
    {
      header: languageHelper("Time Taken (min)"),
      cell: (row) => {
        if (
          !row.row.original.cooking_start_time ||
          !row.row.original.cooking_end_time
        ) {
          return "N/A";
        }
        const start = new Date(
          row.row.original.cooking_start_time.replace(" ", "T")
        );
        const end = new Date(
          row.row.original.cooking_end_time.replace(" ", "T")
        );

        const diffMs = end - start;
        const diffMinutes = diffMs / (1000 * 60);

        return diffMinutes.toFixed(1); // e.g. 2.5
      },
    },
  ];
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [data, setData] = useState([]);
  const buttonData = [
    {
      buttonText: languageHelper("Submit"),
      func: () => handleSubmit(),
    },
  ];

  const handleSubmit = () => {
    axios
      .get(`${apiKey}/api/rms/admin/kitchen-performance-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`
        },
        params: {
          outletId: user?.user?.outlet_id,
          from: startDate,
          to: endDate,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Kitchen Performance Report")}
        // buttonDataa={buttonData}
        ctaData={buttonData}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
    </main>
  );
}

export default KitchenPerformanceReport;
